import React from 'react';
export function Footer() {
  return <footer className="bg-dark-card border-t border-dark-border pt-12 pb-8 px-4 text-center" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <div className="mb-8" data-id="element-136">
          <div className="inline-flex items-center space-x-2 text-2xl font-black mb-4 text-slate-900" data-id="element-137">
            <span data-id="element-138">🧠</span>
            <span data-id="element-139">ULTRAPACK PSICO PRO™</span>
          </div>
          <p className="text-slate-600 max-w-md mx-auto" data-id="element-140">
            El sistema de sesiones N°1 para Psicólogas en Argentina.
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-141">
            Porque ejercer la Psicología Clínica no debería costarte todos los
            domingos del año.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500 mb-8" data-id="element-142">
          <a href="mailto:soporte@ultrapack-digital.com" className="hover:text-brand transition-colors" data-id="element-143">
            📧 soporte@ultrapack-digital.com
          </a>
          <a href="#" className="hover:text-brand transition-colors" data-id="element-144">
            📱 @ultrapack.digital
          </a>
        </div>

        <div className="border-t border-dark-border/50 pt-6 text-xs text-slate-500" data-id="element-145">
          <p className="mb-2" data-id="element-146">
            © Ultrapack Digital™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}